import React from 'react';
import SelectStartDate from '../../controllers/SelectStartDate';
import SelectRooms from '../../controllers/SelectRooms';
import { actionsEnum, dateSettingValueEnum, fieldNames } from '../../constants';
import Period from '../../controllers/Period';
import SelectEndDate from '../../controllers/SelectEndDate';
import SelectDateSetting from '../../controllers/SelectDateSetting';
import { useFormWatch } from '../../../../../../helpers/formManager';
import SelectAction from '../../controllers/SelectAction';
import SelectCleanableDateEntity from '../../controllers/SelectCleanableDateEntity';
import styles from './index.module.scss';

const Body = () => {
  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <SelectAction />
        <SelectEntity />
        <SelectDate />
      </div>

      <SelectRooms />
    </div>
  );
};

export default Body;

const selectEntityFields = {
  [actionsEnum.SET]: <SelectDateSetting />,
  [actionsEnum.CLEAR]: <SelectCleanableDateEntity />,
};
function SelectEntity() {
  const action = useFormWatch({ name: fieldNames.action, exact: true });

  return selectEntityFields[action] ?? null;
}

const fields = {
  [dateSettingValueEnum.START_DATE]: <SelectStartDate />,
  [dateSettingValueEnum.END_DATE]: <SelectEndDate />,
  [dateSettingValueEnum.PERIOD]: <Period />,
};

function SelectDate() {
  const setting = useFormWatch({ name: fieldNames.dateSetting, exact: true });

  return fields[setting] ?? null;
}
